import { render } from "./InvoiceTopBar.vue?vue&type=template&id=063a05dd&scoped=true"
import script from "./InvoiceTopBar.vue?vue&type=script&lang=js"
export * from "./InvoiceTopBar.vue?vue&type=script&lang=js"

import "./InvoiceTopBar.vue?vue&type=style&index=0&id=063a05dd&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\workInProgress\\invoice-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-063a05dd"]])

export default __exports__